import axios from '@/plugins/axios'

export default {
    getLoadingSettings(){
        return axios({
            url: '/loading-screen/settings',
            method: 'get'
        });
    },
    saveAllSettings(data) {
        return axios({
            url: '/loading-screen/settings',
            method: 'post',
            data
        });
    }
}
